import { css } from 'styled-components';
export const whiteSpace = css `
  ${({ $whiteSpace }) => `
    ${$whiteSpace ? `white-space: ${$whiteSpace};` : ''}
  `}
`;
export const whiteSpaceKeys = ['whiteSpace'];
